import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { CreateUserForm } from './use-create-user-form';

export const useCreateUserFormContext = ():
  | UseFormReturn<CreateUserForm>
  | never => {
  const form = useFormContext<CreateUserForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useCreateUserFormContext can only be used inside a Edit User Form Context Provider.',
    );

  return form;
};
